import React, { useEffect, useState, useRef, useContext } from "react";
import { appLayoutStore, deleteUploadedFile } from "../../../contexts";
import { deleteUploadedFileById } from "../../../services";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  Row,
  Col,
  Image,
  Tab,
  Tabs,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import {
  faExclamationTriangle,
  faTimes,
  faTrashAlt,
  faRedo,
} from "@fortawesome/pro-light-svg-icons";
import ErrorReports from "./ErrorReportsTypes/ErrorReports";
import WarningReports from "./ErrorReportsTypes/WarningReports";
import AllRecordReports from "./ErrorReportsTypes/AllRecordReports";
import errorReports from "../../../mocks/errorReports.json";
import allRecordReports from "../../../mocks/allRecordReports.json";
import warningReports from "../../../mocks/warningReports.json";
import { Link } from "react-router-dom";
import { MANAGE_PAYROLL_ROUTES } from "../../../utils";
import { camelCase, get, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import upload from "../../../styles/upload.png";
import sftp from "../../../styles/ftp.png";
import {
  getWarningsInECR,
  getErrorsInECR,
  getAllRecords,
  getRevalidateFile,
  acceptEmployeeWarnings,
  getCountsForErrorReportTabs,
} from "../../../services/payroll/index";
import authService from "../../../components/api-authorization/AuthorizeService";
import { WarningModal } from "../../../components";
import permissions from "../../../mocks/menuPermissions.json";
const ErrorFoundRecords = (props) => {
  const {
    selectedTabIndex,
    setTabIndex,
    setIsLoading,
    isLoading,
    revalidateIds,
    info,
    fileId,
    fileType,
    setRecordsListType,
    tabChange,
    pendingSubmission,
    toggleFileStatus,
    toggleAcceptWarning,
    setEcrSubmit,
    isRecordDeleted,
    setIsRecordDeleted,
    setIsSubmit,
    menu,
    subMenu,
    frequencyList,
    states,
    countries,
    warnings,
    setWarnings,
    errors,
    setErrorRecords,
  } = props;
  //const [selectedTabIndex, setTabIndex] = useState("all_records");

  const [allRecords, setAllRecords] = useState(0);
  const [toggle, setToggle] = useState(true);
  const [countTrigger, setcountTrigger] = useState(false);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [notification, setNotification] = useState([]);

  const fileStatus = get(info, "fileStatus", "");
  const hideRevalidate =
    fileStatus === "AwaitingFunding" ||
    fileStatus === "AwaitingFundConfirmation" ||
    fileStatus === "AwaitingTrade"
      ? true
      : false;
  const revalidateFile = {
    userId: 1,
    uploadedFileType: info.fileType || fileType,
    fileUploadId: parseInt(fileId),
  };
  const [request, setRequest] = useState({
    fileId: fileId,
    from: 0,
    offset: 20,
  });
  const isFirstRun = useRef(true);
  const isFirstFetch = useRef(true);
  const { state: state2 } = useContext(appLayoutStore);
  const [showmodal, setShowmodal] = useState(false);
  const history = useHistory();
  const handleConfirmClick = () => {
    deleteUploadedFileById(parseInt(fileId))
      .then((response) => {
        history.push({
          pathname: MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD,
        });
        // dispatch(
        //   setManagePayrollToastInfo({
        //     showToast: false,
        //     toastMessage: "File Deleted Successfully",
        //   })
        // )
        return response; 
      })
      .catch((error) => {
        throw error;
      });
  };
  const handleCancelClick = () => {
    setShowmodal(false);
  };
  useEffect(() => {
    setIsLoading(true);
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    getWarningsInECR(request).then((response) => {
      setIsLoading(false);
      setWarnings(response.filter((x) => x.referenceId !== 0).map((x) => x));
      var not = response.filter((x) => x.referenceId === 0);
      setNotification(not);
      if (not.length > 0) setisModalOpen(true);
    });
  }, [toggle, countTrigger]);

  // useEffect(() => {
  //   getErrorsInECR(request).then((response) => {
  //     setErrors(response.map((x) => x.employeeErrors.length));
  //   });
  // }, [toggle]);
  // useEffect(() => {
  //   getAllRecords(request).then((response) => {
  //     setAllRecords(response.errorReportDetails);
  //   });
  // }, [toggle]);
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  useEffect(() => {
    setIsLoading(true);
    if (isFirstFetch.current) {
      isFirstFetch.current = false;
      return;
    }
    getCountsForErrorReportTabs(parseInt(fileId, 10)).then((response) => {
      if (!isEmpty(response)) {
        setIsLoading(false);
        setErrorRecords(response.errorsCount);
        setAllRecords(response.employeeCount);
      }
      //warnings.current = response.warningsCount
    });
  }, [toggle, countTrigger]);

  const recordsType = {};
  const onTabSelect = (id) => {
    if (id === "reupload") {
      setShowmodal(true);
      return; // prevent active tab change
    }
    setTabIndex(id);
    setRecordsListType(id);
    //  if (id == "all_records") setRecordsListType("errors");
    //  else setRecordsListType(id);
  };
  // const warningLength = warningReports.reduce((sum, current) => {
  //   return sum + current.warningCount;
  // }, 0);
  const toggleUseEffect = () => {
    setToggle(!toggle);
    toggleFileStatus();
  };
  const handleClose = () => {
    setisModalOpen(false);
  };
  const AcceptNotificationClick = () => {
    //values.acceptWarning = true;
    setisModalOpen(false);
    acceptEmployeeWarnings({
      acceptedWarningIds: notification.map((x) => x.lookUpId[0]),
      fileUploadId: fileId,
    });
  };
  return (
    <div className="file-information">
      <div className="d-flex flex-row w-100">
        <div className="w-100">
          <Tabs
            defaultActiveKey="all_records"
            transition={false}
            className="top-level-tab-var mb-4"
            onSelect={onTabSelect}
            activeKey={selectedTabIndex}
            mountOnEnter
            unmountOnExit
          >
            <Tab
              eventKey="all_records"
              title={
                <div className="d-flex onselect-highlight-error">
                  <div className="mt-1">All records</div>{" "}
                  <div
                    className="circle-error-count"
                    style={{
                      background: "#919191",
                    }}
                  >
                    {allRecords}
                  </div>{" "}
                </div>
              }
            >
              {allRecords != null ? (
                // allRecords > 0 ? (
                <AllRecordReports
                  setIsSubmit={setIsSubmit}
                  fileId={fileId}
                  setcountTrigger={setcountTrigger}
                  countTrigger={countTrigger}
                  pendingSubmission={pendingSubmission}
                  homeSetIsLoading={setIsLoading}
                  toggleUseEffect={toggleUseEffect}
                  isRecordDeleted={isRecordDeleted}
                  setIsRecordDeleted={setIsRecordDeleted}
                  allRecords={allRecords}
                  menu={"payroll"}
                  subMenu={"uploadFile"}
                  revalidateIds={revalidateIds}
                  revalidateFile={revalidateFile}
                  countries={countries}
                  states={states}
                  frequencyList={frequencyList}
                />
              ) : // ) :
              // (
              //   "No Records Found"
              // )
              null}
            </Tab>
            <Tab
              eventKey="warning"
              title={
                <div className="d-flex onselect-highlight-error">
                  <div className="mt-1">Warnings</div>{" "}
                  <div
                    className="circle-error-count"
                    style={{
                      background: "#919191",
                    }}
                  >
                    {warnings?.length ?? 0}
                  </div>{" "}
                </div>
              }
            >
              {warnings != null ? (
                //  warnings?.length > 0 ? (
                <WarningReports
                  NoOfErrors={errors}
                  setIsLoading={setIsLoading}
                  isLoading={isLoading}
                  setEcrSubmit={setEcrSubmit}
                  countTrigger={countTrigger}
                  setcountTrigger={setcountTrigger}
                  fileId={fileId}
                  toggleUseEffect={toggleUseEffect}
                  tabChange={tabChange}
                  toggleAcceptWarning={toggleAcceptWarning}
                  menu={"payroll"}
                  subMenu={"uploadFile"}
                  revalidateIds={revalidateIds}
                  revalidateFile={revalidateFile}
                  allRecords={allRecords}
                  countries={countries}
                  states={states}
                  frequencyList={frequencyList}
                />
              ) : // ) :
              // (
              //   "No Records Found"
              // )
              null}
            </Tab>
            <Tab
              eventKey="errors"
              title={
                <div className="d-flex onselect-highlight-error">
                  <div className="mt-1">Errors</div>{" "}
                  <div
                    className="circle-error-count"
                    style={{
                      background: "#919191",
                    }}
                  >
                    {errors}
                  </div>{" "}
                </div>
              }
            >
              {errors != null ? (
                // errors > 0 ? (
                <ErrorReports
                  countTrigger={countTrigger}
                  setcountTrigger={setcountTrigger}
                  fileId={fileId}
                  homeSetIsLoading={setIsLoading}
                  toggleUseEffect={toggleUseEffect}
                  menu={"payroll"}
                  subMenu={"uploadFile"}
                  revalidateIds={revalidateIds}
                  errors={errors}
                  revalidateFile={revalidateFile}
                  setIsSubmit={setIsSubmit}
                  countries={countries}
                  states={states}
                  frequencyList={frequencyList}
                />
              ) : null}
            </Tab>
            <Tab
              eventKey="reupload"
              tabClassName="ms-auto reupload-tab"
              title={
                <>
                  {permissions?.[roleName]?.["payrollSubMenu"]?.[
                    "reUploadFile"
                  ]?.includes("C") && (
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon
                        icon={faRedo}
                        className="me-2 primary-color"
                        style={{ marginRight: "5px" }}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent tab switching
                          setShowmodal(true);
                        }}
                      />
                      <span
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent tab switching
                          setShowmodal(true);
                        }}
                        className="me-2 primary-color"
                        // style={{ cursor: "pointer" }}
                      >
                        Reupload
                      </span>
                    </div>
                  )}
                </>
              }
            />
          </Tabs>
        </div>
      </div>
      <Modal show={isModalOpen} onHide={handleClose}>
        <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
          <div className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleClose}
            />
          </div>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div className="remove-text">
              {notification.map((x) => (
                <p>{x.messageDescCode} </p>
              ))}

              <br />
              <Button
                className="remove-btn mr-4"
                onClick={AcceptNotificationClick}
              >
                Ok
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <WarningModal show={showmodal} onHide={handleCancelClick}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>
            You are attempting to reupload the file. This file will be deleted
            and you will be navigated to the payroll upload page. Do you wish to
            continue?
          </p>
          <Button className="remove-btn mr-4" onClick={handleConfirmClick}>
            Yes
          </Button>
          <Button className="cancel-btn" onClick={handleCancelClick}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};

export default ErrorFoundRecords;
